import { variables } from "./components/variables";
import Choices from "choices.js";

(function($) {


    /**
     * Add Choices.js to select dropdowns
     */
    const $selects = $('select');
    $selects.each(function(){
      
        // Handle tab selects only on mobile
        if ( $(this).hasClass('bde-tabs__select') && screen_width > variables.largeTabletBreakpoint ) {
            return;
        }

        const selectChoice = new Choices($(this)[0], {
            allowHTML: true,
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: ""
        });

        $(this).on('choiceBridge', function(event, newValue) {
            selectChoice.setChoiceByValue(newValue);
        });
    });


    /**
     * Form Fields with inner label: Adjust label spacing
     */
    function adjustFieldsWithInnerLabels() {
        const $fields = $('.frm_inside_container');
        $fields.each(function(){
            const $label = $(this).find('.frm_primary_label');
            if ( $label ) {
                $(this).css('--labelHeight', $label.height() + 'px');
            }
        });
    }
    adjustFieldsWithInnerLabels();
    $(window).on('resize', adjustFieldsWithInnerLabels);


    /**
     * Trigger ScrollTrigger refresh after Breakdance accordion animations to recalculate sticky elements
     */
    $('.bde-accordion__panel').on('transitionend', function(){
        if (typeof ScrollTrigger != "undefined") {
            ScrollTrigger.refresh();
        }
    });


    /**
     * On Window Load, force window resize event to make sure certain elements (Breakdance post loops, etc) stack correctly
     */
    window.onload = (event) => {
        $(window).trigger('resize');
    };

	
})( jQuery );

